<template>
  <div class="ts-space-y-3">
    <div class="ts-flex ts-space-x-2">
      <input
        v-model="search"
        type="number"
        :placeholder="$t('claimPayout.search')"
        class="form-control"
      />
      <ts-button
        color="primary"
        :waiting="waiting_search"
        @click.prevent="onSearch"
      >{{ $t('claimPayout.btnSearch') }}</ts-button>
    </div>
    <div class="ts-mt-4 ts-space-x-3" v-if="message">
      <i class="fas fa-exclamation-triangle ts-text-red-600"></i>
      <span class="ts-font-heading-font ts-pr-5 ts-text-red-600">{{ message }}</span>
    </div>
    <div class="ts-mt-4 ts-space-x-3" v-if="!model.payout_balance && message">
      <p>
        <span class="ts-font-semibold">{{ $t('claimPayout.payoutBalance') }}</span> :
        <span>{{ model.payout_balance }}</span>
      </p>
    </div>
    <div class="ts-w-full ts-space-y-4" v-if="model.payout_balance > 0">
			<p>
				<span class="ts-font-semibold">{{ $t('claimPayout.dealerName') }}</span> : 
				<span>{{ model.dealer_name }}</span> 
			</p>
      <input
        v-model.number="model.claim_amount"
        type="number"
        class="form-control"
        :placeholder="$t('claimPayout.amount')"
      />
      <div class="validate" v-if="errors.has('claim_amount')">{{ errors.first('claim_amount') }}</div>
      <textarea
        v-model.trim="model.description"
        rows="3"
        class="form-control"
        :placeholder="$t('claimPayout.description')"
      ></textarea>
      <div class="ts-space-x-4 ts-flex ts-justify-end">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" :waiting="waiting" @click.prevent="onSave">{{ $t('save') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'frmSearchDealer',
  data() {
    return {
      search: null,
      waiting_search: false,
      waiting: false,
      message: null,
      errors: new Errors(),
      model: {
        claim_amount: null,
        dealer_id: null,
        description: null,
				payout_balance: 0,
				dealer_name: null
      }
    }
  },
  methods: {
    ...mapActions('accounting/claimPayout', ['getDealer', 'store']),
    onSearch() {
      this.message = null
      if (!this.search) {
        return
      }
      this.waiting_search = true
      this.getDealer(this.search)
        .then(response => {
          this.createData(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_search = false
        })
    },
    createData(data) {
      if (data.length > 0) {
        let item = data[0]
        if (item.payout_balance == 0) {
          this.message = this.$t('claimPayout.noPayoutBalanceToClaim')
        } else {
          this.model.dealer_id = item.dealer_id
          this.model.payout_balance = item.payout_balance
          this.model.dealer_name = item.dealer_name
        }
      } else {
        this.message = this.$t('claimPayout.notFoundPhoneNumber')
      }
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
					this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
			this.errors = new Errors()
			this.message = null
			this.search = null
      this.model.claim_amount = null
      this.model.dealer_id = null
      this.model.dealer_name = null
      this.model.description = null
      this.model.payout_balance = 0
    }
  }
}
</script>